import * as angular from 'angular';

import { IJobDefinitionDto, JobDefinitionDto } from '../../models/DTO/JobDefinitionDto';
import { ComputationJobDefinition } from '../../models/entities/ComputationJobDefinition';
import { IRequestService } from '../../services';

export interface IJobDefinitionService {
    get(guid: string): angular.IPromise<IJobDefinitionDto>;
    getAll(): angular.IPromise<IJobDefinitionDto[]>;
    update(job: ComputationJobDefinition): angular.IPromise<JobDefinitionDto[]>;
    clearInactive(): angular.IPromise<JobDefinitionDto[]>;
}

export class JobDefinitionService implements IJobDefinitionService {
    static serviceId = 'jobDefinitionService';
    
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    get(guid: string): angular.IPromise<IJobDefinitionDto> {
        const url = `jobDefinition/${guid}`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService
            .getAtV1<JobDefinitionDto>(url)
            .then(data => data.jobDefinition);
    }

    getAll(): angular.IPromise<IJobDefinitionDto[]> {
        const url = `jobDefinition/`;
        this._requestService.cleanCacheAtV1(url);
        return this._requestService
            .getAtV1<JobDefinitionDto[]>(url)
            .then(data => data.map(j => j.jobDefinition));
    }

    update(job: ComputationJobDefinition): angular.IPromise<JobDefinitionDto[]> {
        this._requestService.cleanCacheAtV1('jobDefinition/');
        return this._requestService.postAtV1('jobDefinition/update/', job);
    }

    clearInactive(): angular.IPromise<JobDefinitionDto[]> {
        return this._requestService
            .postAtV1<JobDefinitionDto[]>('jobDefinition/inactive/')
            .then(data => {
                this._requestService.cleanCacheAtV1('jobDefinition/');
                return data;
            });
    }
}
